var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('banner'),_c('topbar'),_c('section',{staticClass:"content container",attrs:{"id":"content"}},[_c('banner-slider'),_c('keep-alive',{attrs:{"include":['home']}},[_c('router-view')],1)],1),_c('bottombar'),_c('modals'),_c('v-cookies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }